import { render } from "./DetailList.vue?vue&type=template&id=dbe684f2&scoped=true"
import script from "./DetailList.vue?vue&type=script&lang=js"
export * from "./DetailList.vue?vue&type=script&lang=js"

import "./DetailList.vue?vue&type=style&index=0&id=dbe684f2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbe684f2"]])

export default __exports__